import React from 'react';
import { Meeting } from '@/types';

interface AgendaMeetingProps {
  meeting: Meeting;
  onMeetingClick: (meeting: Meeting) => void;
}

const AgendaMeeting: React.FC<AgendaMeetingProps> = ({ meeting, onMeetingClick }) => {
  return (
    <div
      key={meeting.id}
      className="mb-2 p-2 bg-blue-100 text-black rounded cursor-pointer hover:opacity-90 transition-opacity dark:bg-blue-900 dark:text-blue-200"
      onClick={() => onMeetingClick(meeting)}
    >
      <div className="text-sm">{meeting.name || '(No title)'}</div>
      <div className="text-xs opacity-90 text-gray-600 mt-1 dark:text-blue-400">
        {new Date(meeting.starts_at).toLocaleTimeString([], {
          hour: 'numeric',
          minute: '2-digit',
          hour12: true,
        })}
        {' - '}
        {new Date(meeting.ends_at).toLocaleTimeString([], {
          hour: 'numeric',
          minute: '2-digit',
          hour12: true,
        })}
      </div>
      <div className="text-xs text-gray-600 dark:text-gray-400 mt-1">
        <div className="flex items-center gap-2">
          {meeting.account?.logo_url && (
            <img
              src={meeting.account?.logo_url}
              alt={meeting.account?.name}
              className="w-4 h-4 rounded-full"
            />
          )}
          {meeting.account?.name}
        </div>
      </div>
    </div>
  );
};

export default AgendaMeeting;
